import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ServiceSubscription } from '../models/service-subscription';
import { CrudService } from './crud-service';
import { MemoryService } from './memory.service';

@Injectable({
    providedIn: 'root',
})
export class ServiceSubscriptionsService extends CrudService {
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    List(): Observable<ServiceSubscription[]> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
        };

        // Appel de la Web Api
        return this.http.get<ServiceSubscription[]>(this.baseUrl + `/api/organizations/${this.organizationId}/subscriptions`, httpOptions).pipe(
            map((x) => {
                return x.map((value) => ServiceSubscription.createInstanceFromJson(value));
            })
        );
    }

    update(serviceSubscriptionId: number, serviceSubscription: ServiceSubscription): Observable<ServiceSubscription> {
        // Appel de la Web Api
        return this.http
            .put<ServiceSubscription>(
                this.baseUrl + `/api/organizations/${this.organizationId}/subscriptions/${serviceSubscriptionId}`,
                serviceSubscription,
                this.getDefaultHttpOptions()
            )
            .pipe(
                map((x) => {
                    return x;
                })
            );
    }
}
